<template>
  <div class="card-video block-card card-border ">
    <v-expansion-panel
      :value="panel"
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <span class="botter-analysis-icon white--text text-lg-2" />
            </div>
            <h4>
              Funnel
              <v-icon
                v-if = "errorsCount.errorsCount"
                color = "error"
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body" v-if="validData">

            <label> Name </label>
            <vTextareaAutocomplete
              v-model="data.name"
              :validation-rules="autocompleteVideoValidationRules"
              type="textfield" />
            <label>Attribute</label>

            <v-autocomplete
              :items="variables"
              v-model="data.attributes"
              :error="data.attributes && data.attributes.length < 0"
              :error-messages="data.attributes && data.attributes.length < 0? 'Attribute is Required':'' "
              item-text="variable"
              class="left-radius"
              item-value="variable"
              outline
              chips
              multiple
              solo
            >
              <template v-slot:selection="dataList">
                <v-chip
                  :selected="dataList.selected"
                  close
                  color="#333"
                  @input="data.attributes.splice(data.attributes.indexOf(dataList.item.variable), 1)"
                >
                  <strong>{{ dataList.item.variable }}</strong>&nbsp;
                </v-chip>
              </template>
            </v-autocomplete>
          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
  import common from '../../../../utils/common'
  import FormValidation from '../FormValidation'
  export default {
    name: 'funnelCard',
    components: {
      FormValidation
    },
    props: {
      data: {
        type: Object,
        default: () => {
          return {}
        }
      },
      index: {
        type: Number,
        default: () => {
          return 0
        }
      },
      blocksList: {
        type: Array,
        default: () => {
          return []
        }
      },
      validData: {
        type: Boolean,
        default: ()=> {
          return false
        }
      }
    },
    data() {
      return {
        errorsCount: { errorsCount: 0 },
        lazyRendering: true,
        valid: true,
        panel: 1,
        common,
        autocompleteVideoValidationRules: [v => !!v || 'Name is Required'],
        autocompleteVideoValidationRulesDesc: [
          v => !!v || 'Description is Required',
          v =>
            (v && v.length < 80) ||
            'Description should be less than 80 character'
        ],
        autocompleteVideoValidationRulesTitle: [
          v => !!v || 'Title is Required',
          v =>
            (v && v.length < 80) ||
            'Title should be less than 80 character'
        ]
      }
    },
    computed: {
      variables() {
        return this.$store.state.blocksBuild.variables
      }
    },
    watch: {
      errorsCount(val) {
        this.$emit('input', { errorsCount: val.errorsCount })
        this.data.errorsCount = val.errorsCount
      }
    },
    mounted() {
      if (this.data.errorsCount !== undefined) {
        this.errorsCount = this.data.errorsCount
      } else {
        // disabling Lazy rendering so we can grip errors count
        this.lazyRendering = false
        setTimeout(() => {
          // then we turn it on again to keep the performance up
          this.lazyRendering = true
        }, 1000)
      }
    },
    methods: {},

  }
</script>

<style scoped>
</style>
